import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight, MapPin } from "lucide-react";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import CartDrawer from "@/components/feature/CartDrawer";
import { socialLinks } from "@/data/social";
import { store } from "@/services/store";
import "./about.css";

const mapLink = (address: string) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Sobre a Bozzetti | Bozzetti Store";
  }, []);

  return (
    <div className="bz-page">
      <Header />
      <main>
        <section className="bz-about-hero">
          <div className="bz-about-copy">
            <p>Sobre nós</p>
            <h1>Bozzetti Store</h1>
            <span>A Bozzetti Store é uma das maiores e mais renomadas atacadistas de alfaiataria feminina de São Paulo. Há mais de 5 anos, é referência em qualidade, estilo e compromisso com o sucesso do comércio de moda.</span>
            <Link to="/produtos">Ver a coleção <ArrowRight size={14} aria-hidden="true" /></Link>
          </div>
          <img src={`${import.meta.env.BASE_URL}editorial/banner-azul.webp`} alt="Modelo entre palmeiras, vestindo conjunto azul de alfaiataria" />
        </section>

        <section aria-labelledby="bz-about-units">
          <header className="bz-shelf-head"><div><p>Onde estamos</p><h2 id="bz-about-units">Nossas unidades</h2></div></header>
          <ul className="bz-about-units">
            {store.units.map((unit) => (
              <li key={unit.name}>
                <MapPin size={22} strokeWidth={1.5} aria-hidden="true" />
                <h3>{unit.name}</h3>
                <p>{unit.address}</p>
                <a href={mapLink(unit.mapQuery)} target="_blank" rel="noopener noreferrer">Ver no mapa <ArrowUpRight size={15} aria-hidden="true" /></a>
              </li>
            ))}
          </ul>
        </section>

        <section className="bz-about-social" aria-labelledby="bz-about-follow">
          <div>
            <h2 id="bz-about-follow">Acompanhe a Bozzetti</h2>
            <p>Novidades e bastidores nas nossas redes.</p>
          </div>
          <div className="bz-about-links">
            {socialLinks.map((social) => (
              <a key={social.label} href={social.url} target="_blank" rel="noopener noreferrer">
                <i className={social.icon} aria-hidden="true"></i>{social.label}
              </a>
            ))}
            <a href={store.whatsapp} target="_blank" rel="noopener noreferrer"><i className="ri-whatsapp-line" aria-hidden="true"></i>WhatsApp</a>
          </div>
        </section>
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
}
